import { useEffect, useState } from 'react'

import Api from 'services/api'
import { AlertsHistory } from 'types/Alert'

type Props = {
  dealerId: number
  deviceId: string
  fromTime: string
  toTime: string
  deviceTimeZone: string
}

const useAlertsHistory = ({ dealerId, deviceId, fromTime, toTime, deviceTimeZone }: Props) => {
  const [alertsHistory, setAlertsHistory] = useState<AlertsHistory | null>(null)
  const [areAlertsHistoryLoaded, setAreAlertsHistoryLoaded] = useState(false)

  useEffect(() => {
    setAreAlertsHistoryLoaded(false)

    Api.AlertsHistory.get(dealerId, deviceId, fromTime, toTime, deviceTimeZone)
      .then((res: AlertsHistory | null) => {
        setAlertsHistory(res)
      }).catch(() => {
        setAlertsHistory(null)
      }).finally(() => {
        setAreAlertsHistoryLoaded(true)
      })
  }, [dealerId, deviceId, fromTime, toTime, deviceTimeZone])

  return { alertsHistory, areAlertsHistoryLoaded }
}

export default useAlertsHistory
